// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogNewsContent_container{
    padding: 100px 50px;
    color: #000;
}

.BlogNewsContent_arrow_container{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    margin-bottom: 20px;
    cursor: pointer;
}

.BlogNewsContent_back_arrow{
    color: #FFFFFF;
    background-color: #7A7A7A;
    border-radius: 18px;
    padding: 10px 15px;
}

.BlogNewsContent_heading{
    margin-bottom: 10px;
}

.BlogNewsContent_heading h2{
    margin-bottom: 10px;
    color: #000;
    font-size: 40px;
    font-weight: 750;
    line-height: 55px;
    max-width: 1129px;
}

.BlogNewsContent_heading p{
    color: #7A7A7A;
    font-size: 16px;
    font-weight: 400;
    line-height: 55px;
}

.BlogNewsContent_heading span{
    color: #000;
    font-size: 16px;
    font-weight: 400;
    line-height: 55px;
}

.BlogNewsContent_img_container{
    margin: 20px 0;
    width: 100%;
}

.BlogNewsContent_img_container img{
    width: 100%;
    object-fit: cover;
    /* height: 468px; */
}

.BlogNewsContent_text{
    margin-bottom: 30px;
    color: #000;
    font-size: 18px;
    font-weight: 400;
    line-height: 35px;
}

.BlogNewsContent_btn_container{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.left_btn{
    width: 123px;
}

.left_btn_bg{
    background-color: #7A7A7A !important;
}

.BlogNewsContent_left_btn p{
    color: #7A7A7A;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    width: 340px;
}

.arrow_btn_container{
    display: flex;
    align-items: center;
    gap: 20px;
}

.BlogNewsContent_right_btn p{
    color: #0F0F0F;
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
    width: 340px;
}



@media screen and (max-width: 500px){
    .BlogNewsContent_container{
        padding: 100px 20px;

    }

    .BlogNewsContent_btn_container{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
    }

    .BlogNewsContent_left_btn p, .BlogNewsContent_right_btn p{
        width: auto;
    }
    
    
}`, "",{"version":3,"sources":["webpack://./src/styles/BlogNewsContent.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;;;AAIA;IACI;QACI,mBAAmB;;IAEvB;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,WAAW;IACf;;;AAGJ","sourcesContent":[".BlogNewsContent_container{\n    padding: 100px 50px;\n    color: #000;\n}\n\n.BlogNewsContent_arrow_container{\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 20px;\n    cursor: pointer;\n}\n\n.BlogNewsContent_back_arrow{\n    color: #FFFFFF;\n    background-color: #7A7A7A;\n    border-radius: 18px;\n    padding: 10px 15px;\n}\n\n.BlogNewsContent_heading{\n    margin-bottom: 10px;\n}\n\n.BlogNewsContent_heading h2{\n    margin-bottom: 10px;\n    color: #000;\n    font-size: 40px;\n    font-weight: 750;\n    line-height: 55px;\n    max-width: 1129px;\n}\n\n.BlogNewsContent_heading p{\n    color: #7A7A7A;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 55px;\n}\n\n.BlogNewsContent_heading span{\n    color: #000;\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 55px;\n}\n\n.BlogNewsContent_img_container{\n    margin: 20px 0;\n    width: 100%;\n}\n\n.BlogNewsContent_img_container img{\n    width: 100%;\n    object-fit: cover;\n    /* height: 468px; */\n}\n\n.BlogNewsContent_text{\n    margin-bottom: 30px;\n    color: #000;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 35px;\n}\n\n.BlogNewsContent_btn_container{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.left_btn{\n    width: 123px;\n}\n\n.left_btn_bg{\n    background-color: #7A7A7A !important;\n}\n\n.BlogNewsContent_left_btn p{\n    color: #7A7A7A;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px;\n    width: 340px;\n}\n\n.arrow_btn_container{\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.BlogNewsContent_right_btn p{\n    color: #0F0F0F;\n    font-size: 16px;\n    font-weight: 700;\n    line-height: 20px;\n    width: 340px;\n}\n\n\n\n@media screen and (max-width: 500px){\n    .BlogNewsContent_container{\n        padding: 100px 20px;\n\n    }\n\n    .BlogNewsContent_btn_container{\n        display: flex;\n        flex-direction: column;\n        justify-content: space-between;\n        align-items: center;\n    }\n\n    .BlogNewsContent_left_btn p, .BlogNewsContent_right_btn p{\n        width: auto;\n    }\n    \n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
